// Time units in milliseconds

export const SECOND_MS = 1000
export const MINUTE_MS = SECOND_MS * 60
export const HOUR_MS = MINUTE_MS * 60
export const DAY_MS = HOUR_MS * 24

export function wait(delay) {
  return new Promise(resolve => setTimeout(resolve, delay))
}

export function waitFor(vm, property, expectedValue) {
  return new Promise(resolve => {
    if (vm[property] === expectedValue) return resolve()
    const unwatch = vm.$watch(property, newValue => {
      if (newValue === expectedValue) {
        resolve()
        unwatch()
      }
    })
  })
}
